class Tabs {
  constructor(element, config = {}) {
    this.tabBtns = element.querySelectorAll('.js-tabBtn');
    this.tabs = element.querySelectorAll('.js-tab');

    this.classes = {
      tabBtnActive: config.tabBtnActiveClass || '',
      tabActive: config.tabActiveClass || '',
    };

    this.initTabBtns();
  }

  initTabBtns() {
    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.tabBtns.forEach((otherBtn) => {
          if (otherBtn === btn) {
            otherBtn.classList.add(this.classes.tabBtnActive);
          } else {
            otherBtn.classList.remove(this.classes.tabBtnActive);
          }
        });

        const { name } = btn.dataset;

        this.tabs.forEach((tab) => {
          if (tab.dataset.name === name) {
            tab.hidden = false;
            tab.classList.add(this.classes.tabActive);
          } else {
            tab.classList.remove(this.classes.tabActive);
            tab.hidden = true;
          }
        });
      });
    });
  }
}

export default (element, config) => new Tabs(element, config);
